import { DropdownSmall } from "@wix/wix-ui-icons-common";
import { TIPTAP_COLLAPSIBLE_LIST_TYPE } from "./../ricos-content";
import { findNodeClosestToSelection } from "./../ricos-plugins";
import {
  createShortcut,
  quickActionsModalSections,
  RicosPluginToolbarNames
} from "./../ricos-types";
import { changeSelectionToEndOfTextBlock } from "./../wix-rich-content-common";
import {
  collapsibleItemBodyConverter,
  collapsibleItemConverter,
  collapsibleItemTitleConverter,
  collapsibleListConverter
} from "./collapsible-list-converters";
import { DEFAULTS } from "./defaults";
import { getAddButtons } from "./getAddButtons";
import { getToolbarButtons } from "./getToolbarButtons";
import { CollapsibleListSettingsModal } from "./modals/SettingsModals";
import { defaultCollapsibleList } from "./tiptap/defaults";
import { tiptapExtensions } from "./tiptap/tiptap";
import { COLLAPSIBLE_LIST_TYPE } from "./types";
const pluginCollapsibleList = (config) => {
  const pluginConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    type: COLLAPSIBLE_LIST_TYPE,
    pmMarkConverters: [],
    pmNodeConverters: [
      collapsibleListConverter,
      collapsibleItemConverter,
      collapsibleItemTitleConverter,
      collapsibleItemBodyConverter
    ],
    tiptapExtensions,
    getAddButtons,
    toolbar: {
      names: [RicosPluginToolbarNames.COLLAPSIBLE_LIST],
      getButtons: getToolbarButtons,
      isVisible: (_, { adapter: { tiptapEditor } }) => {
        return findNodeClosestToSelection(tiptapEditor, TIPTAP_COLLAPSIBLE_LIST_TYPE) !== null;
      },
      resolveReferenceElement: (tiptapEditor) => {
        return findNodeClosestToSelection(tiptapEditor, TIPTAP_COLLAPSIBLE_LIST_TYPE)?.element ?? null;
      }
    },
    shortcuts: [
      createShortcut({
        name: "MoveToNextElementTab",
        description: "ShortcutsSheet_CollapsibleList_MoveToNextElement",
        group: "ShortcutsSheet_Section_CollapsibleList",
        keys: {
          macOs: "Tab",
          windows: "Tab"
        },
        enabled: false,
        command: () => {
        }
      }),
      createShortcut({
        name: "MoveToNextElementEnter",
        description: "ShortcutsSheet_CollapsibleList_MoveToNextElement",
        group: "ShortcutsSheet_Section_CollapsibleList",
        keys: {
          macOs: "Enter",
          windows: "Enter"
        },
        enabled: false,
        command: () => {
        }
      }),
      createShortcut({
        name: "SelectEntireList",
        description: "ShortcutsSheet_CollapsibleList_SelectTheEntireList",
        group: "ShortcutsSheet_Section_CollapsibleList",
        keys: {
          macOs: "Meta+A",
          windows: "Ctrl+A"
        },
        enabled: false,
        command: () => {
        }
      })
    ],
    getQuickActions: () => [
      {
        id: "expandableList",
        title: "QuickActionsPlugin_ActionTitle_ExpandableList",
        icon: DropdownSmall,
        section: quickActionsModalSections.FormatLayout,
        tags: ["collapsible list", "accordion", "toggle list", "hidden content"],
        command: ({ publicCommands, editor }) => {
          changeSelectionToEndOfTextBlock(editor);
          publicCommands.insertBlockWithBlankLines(COLLAPSIBLE_LIST_TYPE, defaultCollapsibleList, {
            updateSelection: "text"
          });
        }
      }
    ],
    __exports: {
      SettingsModal: CollapsibleListSettingsModal
    }
  };
};
export {
  pluginCollapsibleList
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject";
injectCss();
